class ContactForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.submitButton = this.querySelector("button[type='submit']");

    this.form.addEventListener("focusout", (e) => {
      if (!e.target.required) return;

      if (!e.target.validity.valid) {
        e.target.classList.add("error");
      }
    });

    this.form.addEventListener("input", (e) => {
      if (e.target.validity.valid) {
        e.target.classList.remove("error");
      }

      e.target.classList.remove("indeterminate");
    });

    this.submitButton.addEventListener("click", (e) => {
      const inputs = this.form.querySelectorAll("input, textarea, select");
      let allValid = true;

      inputs.forEach((input) => {
        if (!input.validity.valid) {
          allValid = false;
          input.classList.add("error");
          console.log("input invalid", input);
        } else {
          input.classList.remove("error");
        }
      });

      if (!allValid) {
        e.preventDefault();
      }
    });
  }
}

if (!customElements.get("contact-form")) {
  customElements.define("contact-form", ContactForm);
}
